import "./CustomLinksCell.css";

import { useSelector } from "react-redux";

import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";

import { changeNestedArrKeyValueOnCondition, copyArr } from "core/iterable_utils";
import { getVorTableData } from "slices/vor/vorSelectors";

const CustomLinksCell = ({ rowObj, funcs, upperFuncs, clickedTableClmName }) => {
	const tableData = useSelector(getVorTableData);

	const hideLinks = () => {
		const newTableData = changeNestedArrKeyValueOnCondition({
			arr: copyArr(tableData),
			keySearch: "key",
			valSearch: rowObj.key,
			callback: (row) => {
				let newChildren = [];
				if (row._children) newChildren = row._children.filter((x) => x.model_name !== "VorLink");
				row._children = newChildren;
				row.linksVisible = false;
			},
		});
		funcs.setTableData({ newTableData });
	};

	const showLinks = () => {
		const newTableData = changeNestedArrKeyValueOnCondition({
			arr: copyArr(tableData),
			keySearch: "key",
			valSearch: rowObj.key,
			callback: (row) => {
				const rowLinks = row._links.filter((x) => (x.visible = true));
				let newChildren = [];
				if (row._children) {
					newChildren = [...rowLinks, ...row._children];
				} else {
					newChildren = rowLinks;
				}
				row._children = newChildren;
				row.linksVisible = true;
			},
		});
		funcs.setTableData({ newTableData });
	};

	const PageLinks = ({ strLinks }) => {
		const splitPages = strLinks.split(" ");

		let _className = "VorLinkPageLinks";
		if (rowObj.rowHeightMultiply !== 1 && rowObj.rowHeightMultiply != null) {
			_className = "VorLinkPageLinksMlt";
		}

		return (
			<div className={_className} style={{ display: "flex", justifyContent: "flex-start" }}>
				{splitPages.map((page, index) => {
					return (
						<div className="VorLinkPageLink" key={`${page}-${index}`} onClick={() => upperFuncs.getJust({ rowObj, pageTarget: page })}>
							{page}
						</div>
					);
				})}
			</div>
		);
	};

	if (rowObj.model_name === "VorLink") {
		return (
			<td
				key={`cell-links-${rowObj.key}`}
				className="TableCell"
				clm="_links"
				treecell="false"
				title={String(rowObj.links)}
				is_clicked_clm_name={String(clickedTableClmName === "_links")}
			>
				<div className="CustomVorLinksCell" style={{ textDecoration: "underline", color: "var(--alert-icon-color)" }}>
					<PageLinks strLinks={rowObj._links} />
				</div>
			</td>
		);
	} else {
		return (
			<td
				key={`cell-links-${rowObj.key}`}
				className="TableCell"
				clm="_links"
				treecell="false"
				is_clicked_clm_name={String(clickedTableClmName === "_links")}
			>
				<div className="CustomVorLinksCell">
					{rowObj.linksVisible === true ? (
						<KeyboardArrowDownOutlinedIcon onClick={hideLinks} />
					) : (
						<KeyboardArrowRightOutlinedIcon onClick={showLinks} />
					)}
				</div>
			</td>
		);
	}
};

export default CustomLinksCell;
